<template>
    <v-card>
        <v-card-title>{{ title }} Relationships</v-card-title>
        <v-card-text>
            <v-data-table :headers="tableHeaders"
                :items="relationships"
            />
        </v-card-text>
    </v-card>
</template>
<script setup lang="ts">
import { ref, computed } from "vue";
import _ from "lodash";
import { VDataTableHeader } from "@/vuetifyTypeFixes";
import { ExperimentRelationshipDTO } from "@/services/experimentRelationships/models";

const { type, relationships } = defineProps<{
    type: string;
    relationships: ExperimentRelationshipDTO[];
}>();

const tableHeaders = ref<VDataTableHeader[]>([
    {
        title: "Registry",
        value: "registrySchemaName",
        sortable: true,
        align: "start",
        width: "30%",
    },
    {
        title: "ID",
        value: "registryEntry.id",
        sortable: true,
        align: "start",
        width: "30%",
    },
    {
        title: "Name",
        value: "registryEntry.displayName",
        sortable: true,
        align: "start",
        width: "40%",
    },
]);

const title = computed(() => {
    return _.capitalize(type);
});

</script>
